module.exports = __webpack_public_path__ + "img/soft-bg-3.33ff27a5.png";